import AGREGAR_CATALOGO_CONTRATO_ESTATUS from '@/graphql/mutations/administracion/catalogos/contratoestatus/agregarCatalogoContratoEstatus.gql';
import CONTRATOS_ESTATUS from '@/graphql/querys/administracion/catalogos/contratosestatus/contratosEstatus.gql';
import ACTUALIZAR_CATALOGO_CONTRATO_ESTATUS from '@/graphql/mutations/administracion/catalogos/contratoestatus/actualizarCatalogoContratoEstatus.gql';
import REMOVER_CATALOGO_CONTRATO_ESTATUS from '@/graphql/mutations/administracion/catalogos/contratoestatus/removerCatalogoContratoEstatus.gql';

export default {
  methods: {
    async mixAgregarContratoEstatus() {
      this.enviandoFormulario = true;
      this.mixEsCargando();

      await this.$apollo.mutate({
        mutation: AGREGAR_CATALOGO_CONTRATO_ESTATUS,
        variables: {
          estatus: this.estatus,
        },
        update: (store, { data: { agregarCatalogoContratoEstatus } }) => {
          const data = store.readQuery({ query: CONTRATOS_ESTATUS });
          data.contratosEstatus.push(agregarCatalogoContratoEstatus);
          store.writeQuery({ query: CONTRATOS_ESTATUS, data });
        },
      }).then(() => {
        this.mixMensajeSuccess();
      }).catch((err) => {
        this.mixMensajeError(err);
      });

      this.enviandoFormulario = false;
      this.mixEsCargando();
      this.cerrar();
    },

    async mixActualizarContratoEstatus() {
      this.enviandoFormulario = true;
      this.mixEsCargando();

      await this.$apollo.mutate({
        mutation: ACTUALIZAR_CATALOGO_CONTRATO_ESTATUS,
        variables: {
          id: this.contratoEstatusEditar.id,
          estatus: this.estatus,
        },
        update: (store, { data: { actualizarCatalogoContratoEstatus } }) => {
          const data = store.readQuery({ query: CONTRATOS_ESTATUS });
          const { contratosEstatus } = data;
          const index = contratosEstatus
            .findIndex((contratoEstatus) => contratoEstatus.id
            === actualizarCatalogoContratoEstatus.id);
          if (index !== -1) {
            contratosEstatus.splice(index, 1, actualizarCatalogoContratoEstatus);
          }
          store.writeQuery({ query: CONTRATOS_ESTATUS, data });
        },
      }).then(() => {
        this.mixMensajeSuccess();
      }).catch((err) => {
        this.mixMensajeError(err);
      });

      this.enviandoFormulario = false;
      this.mixEsCargando();
      this.cerrar();
    },

    async mixEliminarEstatusContrato() {
      this.enviandoFormulario = true;
      this.mixEsCargando();

      await this.$apollo.mutate({
        mutation: REMOVER_CATALOGO_CONTRATO_ESTATUS,
        variables: {
          id: this.contratoEstatusEliminar.id,
        },
        update: (store) => {
          const data = store.readQuery({ query: CONTRATOS_ESTATUS });
          const { contratosEstatus } = data;
          const index = contratosEstatus
            .findIndex((contatoEstatus) => contatoEstatus.id === this.contratoEstatusEliminar.id);
          if (index !== -1) {
            contratosEstatus.splice(index, 1);
          }
          store.writeQuery({ query: CONTRATOS_ESTATUS, data });
        },
      }).then(() => {
        this.mixMensajeSuccess();
      }).catch((err) => {
        this.mixMensajeError(err);
      });

      this.enviandoFormulario = false;
      this.mixEsCargando();
      this.cerrar();
    },
  },
};
